import React from 'react';
import { TypedMap } from 'flow/types/TypedMap';
import { MeetingMember } from 'flow/types/Meeting';
import MeetingMinimizedMember from './MeetingMinimizedMember';

interface MemberObject {
    member: TypedMap<MeetingMember>;
}

interface Props {
    ownName?: string;
    membersToRender: MemberObject[];
    numberOfMembersToRender: number;
}

const MeetingMinimizedMembers: React.FC<Props> = ({
    ownName,
    membersToRender,
    numberOfMembersToRender,
}) => (
    <>
        {membersToRender
            .filter(({ member }) => member.get('displayName') !== ownName)
            .map(({ member }) => (
                <MeetingMinimizedMember
                    key={member.get('key')}
                    member={member}
                    widthPercentage={Math.round(100 / numberOfMembersToRender)}
                />
            ))}
    </>
);

export default MeetingMinimizedMembers;
